import { Plus } from "@phosphor-icons/react";

import { Button } from "common/components/ui/Button";

export default function AddNoteButton({ onClick }: { onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex items-center gap-x-2 rounded-3xl border border-dashed border-black-300 bg-white px-3.5 py-3 text-button-sm transition-[background] hover:bg-black-100"
    >
      <Button intent="labelIcon" size="xs">
        <Plus />
      </Button>
      Add note
    </button>
  );
}
